import { create } from 'zustand';
import { CompetencyDataForm } from 'types/dacum/competencyManagement';

type Mode = 'add' | 'edit' | 'view';

interface CompetencyManagementState {
  formData: CompetencyDataForm;
  mode: Mode;
  setFormData: (_data: Partial<CompetencyDataForm>) => void;
  setMode: (_data: Mode) => void;
  reset: () => void;
}

export const useCompetencyManagementStore = create<CompetencyManagementState>((set) => ({
  formData: {
    msCompetencyManagementID: '',
    learningPathProgramID: '',
    dateIn: '',
    description: '',
    keyAction: '',
    msSchoolCompetencyManagementID: '',
    schoolName: '',
    userIn: ''
  },
  mode: 'add',
  setFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data }
    })),
  setMode: (data) => set(() => ({ mode: data })),
  reset: () =>
    set({
      formData: {
        msCompetencyManagementID: '',
        learningPathProgramID: '',
        dateIn: '',
        description: '',
        keyAction: '',
        msSchoolCompetencyManagementID: '',
        schoolName: '',
        userIn: ''
      },
      mode: 'add'
    })
}));
